import React from "react";

import {
  GoalBasedFinancialPlanInsuranceResponse,
  GoalBasedInsuranceType,
  GoalBasedLifeInsuranceType,
} from "@fartherfinance/frontend/api/FinancialPlans/insurance/types";

import { lifeInsuranceOptions } from "@src/multiCustodian/components/FinancialPlans/CreateUpdatePlanFlow/pages/Insurance/constants";
import EmptyCard from "@src/multiCustodian/components/FinancialPlans/CreateUpdatePlanFlow/pages/Shared/EmptyCard/EmptyCard";
import FilledCard from "@src/multiCustodian/components/FinancialPlans/CreateUpdatePlanFlow/pages/Shared/FilledCard/FilledCard";
import toUSD from "@src/utils/toUSD";

interface Props {
  heading: string;
  fullName: string;
  onClick: (insurance: GoalBasedFinancialPlanInsuranceResponse) => void;
  insuranceList: GoalBasedFinancialPlanInsuranceResponse[];
  insuranceType: GoalBasedInsuranceType;
  onAddEmptyInsurance: () => void;
}

const unknownDate = "unknown";

const InsuranceCardListRow: React.FC<Props> = ({
  heading,
  fullName,
  onClick,
  insuranceList,
  onAddEmptyInsurance,
}) => {
  const coverageLabel = "Coverage";

  const getLifeInsuranceTypeByValue = (
    lifeInsuranceType: GoalBasedLifeInsuranceType | undefined
  ) => {
    const type = lifeInsuranceOptions.find(
      (l) => l.value === lifeInsuranceType
    );
    if (type === undefined) {
      return "";
    }

    return type.label;
  };

  const handleOnClick =
    (insurance: GoalBasedFinancialPlanInsuranceResponse) => () => {
      onClick(insurance);
    };

  return insuranceList.length >= 1 ? (
    <React.Fragment>
      {insuranceList.map((insurance) => (
        <FilledCard
          key={insurance.planInsuranceId}
          onClick={handleOnClick(insurance)}
          heading={heading}
          titleRight={getLifeInsuranceTypeByValue(insurance.lifeInsuranceType)}
          text={fullName}
          title={
            insurance.amount
              ? toUSD(Number(insurance.amount), {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                })
              : unknownDate
          }
          subTitle={coverageLabel}
        />
      ))}
    </React.Fragment>
  ) : (
    <EmptyCard onAdd={onAddEmptyInsurance} heading={heading} text={fullName} />
  );
};

export default InsuranceCardListRow;
